export class ContextMenu{

    items: Array<ContextMenuItem> = [];
    addItem(item: ContextMenuItem) {
        this.items.push(item);
    }

}

export class ContextMenuItem {

    caption: string
    onClick?: () => void;
    securityRole: string;

}


export class ContextMenuDivider extends ContextMenuItem {
    constructor() {
        super();
        this.caption = "-";
    }
    
}